import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";

export const requestUnblockAffinityPairing = async (
  id: string
): Promise<{ ok: true }> => {
  return await instance.delete(
    `${ApiRoutesRecommendation.AffinityBlacklist}/${id}`
  );
};
